import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'order-ahead.olo.loading-iframe-url.error-message': {
    id: 'order-ahead.olo.loading-iframe-url.error-message',
    defaultMessage: 'Error loading page',
    description: 'Error message displayed when there is an issue loading the Olo iframe URL for Order Ahead.',
  },
});
